import React, { useState, useCallback } from "react"

import { ReactComponent as DashboardSvg } from 'resources/icons/view/dash_pt1.svg'
import { ReactComponent as ViewSvg } from 'resources/icons/tasks/view_pt1.svg'
import { ReactComponent as ActivitySvg } from 'resources/icons/comment/activity_pt1.svg'

import * as st from './FeatureList.styled.js'

const FeatureList = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const onOpenMenu = useCallback((id, event) => {
    setActiveIndex(id);
    if (window.innerWidth <= 768) {
      setTimeout(() => {
        const element = event.target;
        const rect = element.getBoundingClientRect();
        const offsetTop = rect.top + window.pageYOffset - 80;

        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      }, 350);
    }
  }, [])

  return (
    <st.Wrap>
      <st.List>
        <st.Item isActive={activeIndex === 0}>
          <st.ItemContent>
            <st.ItemButton
              onClick={event => onOpenMenu(0, event)}
            >
              <strong>
                <DashboardSvg />
                Dashboard
              </strong>
              <p>Get visibility into your implementations with powerful dashboard and widgets that provide all project details and insights in a single view.</p>
            </st.ItemButton>
            <st.ItemImageWrap>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/dashboard.webp"
                srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/dashboard.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/visibility/dashboard@2x.webp 2x"
                width={1228}
                height={680}
                alt="Dashboard"
              />
            </st.ItemImageWrap>
          </st.ItemContent>
        </st.Item>
        <st.Item isActive={activeIndex === 1}>
          <st.ItemContent>
            <st.ItemButton
              onClick={event => onOpenMenu(1, event)}
            >
              <strong>
                <ViewSvg />
                Views
              </strong>
              <p>Customizable task views provide the flexibility to manage your work the way you want. Choose from List, Board, or Gallery, combined with advanced filtering and grouping options, to visualize tasks across all projects from any angle.</p>
            </st.ItemButton>
            <st.ItemImageWrap>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/view.webp"
                srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/view.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/visibility/view@2x.webp 2x"
                width={1228}
                height={680}
                alt="Views"
              />
            </st.ItemImageWrap>
          </st.ItemContent>
        </st.Item>
        <st.Item isActive={activeIndex === 2}>
          <st.ItemContent>
            <st.ItemButton
              onClick={event => onOpenMenu(2, event)}
            >
              <strong>
                <ActivitySvg />
                Global Activity
              </strong>
              <p>All project activity across all projects in one place. This is the easiest way to view your team's or customer's activity, whether for today, this week, or a specific time period.</p>
            </st.ItemButton>
            <st.ItemImageWrap>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/activity.webp"
                srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/activity.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/visibility/activity@2x.webp 2x"
                width={1228}
                height={680}
                alt="Activity"
              />
            </st.ItemImageWrap>
          </st.ItemContent>
        </st.Item>
      </st.List>
      <st.ImageOuterWrap>
        <st.ImageWrap key={activeIndex}>
          {activeIndex === 0 ? (
            <img
              src="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/dashboard.webp"
              srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/dashboard.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/visibility/dashboard@2x.webp 2x"
              width={1228}
              height={680}
              alt="Dashboard"
            />
          ) : ""}
          {activeIndex === 1 ? (
            <img
              src="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/view.webp"
              srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/view.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/visibility/view@2x.webp 2x"
              width={1228}
              height={680}
              alt="Views"
            />
          ) : ""}
          {activeIndex === 2 ? (
            <img
              src="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/activity.webp"
              srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/visibility/activity.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/visibility/activity@2x.webp 2x"
              width={1228}
              height={680}
              alt="Activity"
            />
          ) : ""}
        </st.ImageWrap>
      </st.ImageOuterWrap>
    </st.Wrap>
  )
}

export default FeatureList
